import { saveBingSites } from "../../services/socialTokenService";
import { Platform } from "../../types/Platforms";
import { SitePickerProvider } from "../site-connections/types";
import { isBingConfigured } from "./config/bingEnv";
import { BingSite } from "./types/bing.types";

/**
 * Bing Webmaster Tools (SGL-134), connected in the same place as Google Search
 * Console. Bing matters for AI visibility because ChatGPT's live browsing uses
 * Bing's index.
 *
 * The owner pastes their own Bing API key rather than signing in with OAuth, so
 * Bing uses only the shared site picker, never the OAuth callback.
 */
export const bingProvider = {
  platformKey: Platform.BING_WEBMASTER,
  label: "Bing Webmaster Tools",
  isConfigured: isBingConfigured,
  card: {
    logo: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzAwODM3MyIgZD0iTTEyIDRsOCAzdjI2bDExLTYtNS0yLTMtNyAxNSA1djhMMjAgNDRsLTgtNXoiLz48L3N2Zz4=",
    description: "Track how your site performs in Bing — the index ChatGPT searches.",
    buttonClass: "bg-[#008373] hover:bg-[#006b5e]",
    iconClass: "text-teal-700",
  },
};

/**
 * The site picker for one checked key. The key lives only in the caller's component
 * state; it is bound here so the picker can send it with each save and never holds
 * it anywhere else.
 */
export function bingSitePicker(apiKey: string): SitePickerProvider<BingSite> {
  return {
    label: bingProvider.label,
    shortLabel: bingProvider.label,
    siteNoun: { one: "site", many: "sites" },
    save: (customerId, siteUrls, idToken) => saveBingSites(customerId, siteUrls, idToken, apiKey),
    // Only verified sites come back, and Bing has no GSC-style domain/prefix split or
    // permission level to show.
    describeSite: (site) => ({ name: site.site_url, kind: "Verified site" }),
  };
}
